module.exports = __webpack_public_path__ + "img/2x.96cf7fc.jpg";